/* unplugin-vue-components disabled */import { render } from "./ActPage1.vue?vue&type=template&id=e599881e&scoped=true"
import script from "./ActPage1.vue?vue&type=script&lang=js"
export * from "./ActPage1.vue?vue&type=script&lang=js"

import "./ActPage1.vue?vue&type=style&index=0&id=e599881e&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgynew-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e599881e"]])

export default __exports__